/**
 * Koa exposes 4xx errors as a plain text body, while a few middlewares answer with `{ message }`.
 * Both carry the actionable text (stale version, invalid prompt), so surface it instead of a
 * generic failure notice.
 */
export const getMutationErrorMessage = (error: unknown, fallback: string): string => {
  const data = (error as { data?: unknown })?.data;
  if (typeof data === 'string' && data.trim()) return data;
  const message = (data as { message?: unknown })?.message;
  if (typeof message === 'string' && message.trim()) return message;
  return fallback;
};
